export default __webpack_public_path__ + "static/media/bg.e1217dee.webp";